import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Table, Card, Button, Space, Typography, Form, Input, Select, Upload, Cascader,
  Tag, Badge, Alert, Drawer, Tooltip, InputNumber, Divider, Modal, Popconfirm, message
} from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined, DeleteOutlined, EditOutlined, InfoCircleOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;

const PRODUCTS = [
  { value: 'PROD_Q1', label: '智能摄像机Q1' },
  { value: 'PROD_P1', label: '云台机P1' },
  { value: 'PROD_F1', label: '烟雾报警器F1' },
  { value: 'PROD_S1', label: '智能门锁S1' },
  { value: 'PROD_CAM2', label: '户外摄像机C2' },
];

const FIRMWARE_CASCADE = [
  { value: 'fw_main', label: '主控固件', children: [
    { value: 'fw_main_v1.0', label: 'V1.0.0' },
    { value: 'fw_main_v1.1', label: 'V1.1.0' },
    { value: 'fw_main_v2.0', label: 'V2.0.0' },
  ]},
  { value: 'fw_wifi', label: 'WiFi模组固件', children: [
    { value: 'fw_wifi_v1.0', label: 'V1.0.0' },
    { value: 'fw_wifi_v1.2', label: 'V1.2.0' },
  ]},
  { value: 'fw_mcu', label: 'MCU固件', children: [
    { value: 'fw_mcu_v1.0', label: 'V1.0.0' },
    { value: 'fw_mcu_v1.1', label: 'V1.1.0' },
  ]},
];

const TAG_TEMPLATES = [
  { value: 'tpl_1', label: '标准标签模板' },
  { value: 'tpl_2', label: '简易标签模板' },
  { value: 'tpl_3', label: '海外标签模板' },
];

const ProduceConfig = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [createVisible, setCreateVisible] = useState(false);
  const [createForm] = Form.useForm();
  const [editVisible, setEditVisible] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  // 固件添加
  const [addingProdFw, setAddingProdFw] = useState(false);
  const [addingUpgFw, setAddingUpgFw] = useState(false);
  const [prodFwList, setProdFwList] = useState([]);
  const [upgFwList, setUpgFwList] = useState([]);
  const [fwCascade, setFwCascade] = useState(null);
  const [fwRemark, setFwRemark] = useState('');
  // 默认值弹窗
  const [defaultValVisible, setDefaultValVisible] = useState(false);
  const [defaultValForm] = Form.useForm();

  const dataSource = [
    { key: '1', productName: '智能摄像机Q1', productId: 'PROD_Q1', authCode: 'HMY', tagTemplate: '标准标签模板', prodFw: true, upgFw: true },
    { key: '2', productName: '云台机P1', productId: 'PROD_P1', authCode: 'HMY', tagTemplate: '海外标签模板', prodFw: true, upgFw: false },
    { key: '3', productName: '烟雾报警器F1', productId: 'PROD_F1', authCode: 'HMY', tagTemplate: null, prodFw: false, upgFw: false },
  ];

  const columns = [
    { title: '序号', width: 60, align: 'center', render: (_, __, i) => i + 1 },
    { title: '产品信息', key: 'product', width: 150, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.productName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.productId}</Text></div>) },
    { title: '授权规则', dataIndex: 'authCode', width: 150, render: (v) => <Text code>010 + {v} + 年月日 + 随机数</Text> },
    { title: '标签模板', dataIndex: 'tagTemplate', width: 120, render: (v) => v ? <Tag>{v}</Tag> : <Text type="secondary">未配置</Text> },
    { title: '生产固件', dataIndex: 'prodFw', width: 100, align: 'center', render: (v) => v ? <Badge status="success" text="已配置" /> : <Badge status="default" text="未配置" /> },
    { title: '升级固件', dataIndex: 'upgFw', width: 100, align: 'center', render: (v) => v ? <Badge status="success" text="已配置" /> : <Badge status="default" text="未配置" /> },
    { title: '操作', key: 'action', width: 150, render: (_, r) => (
      <Space size={0} split={<Divider type="vertical" style={{ margin: '0 4px' }} />}>
        <Button type="link" size="small" icon={<EditOutlined />} onClick={() => {
          setEditRecord(r);
          if (r.key === '1') {
            setProdFwList([{ key: 'pf1', fwName: '主控固件', fwVersion: 'V1.0.0', hasConfig: true, remark: '出厂烧录固件' }]);
            setUpgFwList([{ key: 'uf1', fwName: '主控固件', fwVersion: 'V2.0.0', hasConfig: false, remark: '升级到最新版本' }, { key: 'uf2', fwName: 'WiFi模组固件', fwVersion: 'V1.2.0', hasConfig: true, remark: 'WiFi模组升级' }]);
          } else if (r.key === '2') {
            setProdFwList([{ key: 'pf2', fwName: 'MCU固件', fwVersion: 'V1.0.0', hasConfig: true, remark: '' }, { key: 'pf3', fwName: 'WiFi模组固件', fwVersion: 'V1.0.0', hasConfig: false, remark: '基础WiFi固件' }]);
            setUpgFwList([]);
          } else { setProdFwList([]); setUpgFwList([]); }
          setEditVisible(true);
        }}>编辑</Button>
        <Popconfirm title="确认删除该产品配置？" onConfirm={() => message.success('已删除')}>
          <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
        </Popconfirm>
      </Space>
    )},
  ];

  const fwColumns = (list, setList) => [
    { title: '序号', width: 60, align: 'center', render: (_, __, i) => i + 1 },
    { title: '固件版本号', key: 'fw', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.fwName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.fwVersion}</Text></div>) },
    { title: <span>固件配置模版 <Tooltip title="生产固件配置，若生产环节需要烧录固件配置，在下方上传，工单填写要烧录的默认值。若无需生产环节烧录固件配置则忽略。"><InfoCircleOutlined style={{ color: '#8c8c8c' }} /></Tooltip></span>, key: 'config', width: 180, render: (_, r) => r.hasConfig ? (
      <Space>
        <Button type="link" size="small" icon={<DownloadOutlined />} onClick={() => message.success('下载成功')}>下载</Button>
        <Button type="link" size="small" onClick={() => { defaultValForm.resetFields(); setDefaultValVisible(true); }}>查看配置</Button>
      </Space>
    ) : <Text type="secondary">未上传</Text> },
    { title: '备注信息', dataIndex: 'remark', width: 150, render: (t) => t || <Text type="secondary">—</Text> },
    { title: '操作', width: 80, align: 'center', render: (_, r) => <Popconfirm title="确认移除？" onConfirm={() => setList(list.filter(f => f.key !== r.key))}><Button type="link" size="small" danger>移除</Button></Popconfirm> },
  ];

  const handleAddFw = (list, setList, setAdding) => {
    if (!fwCascade || fwCascade.length < 2) { message.warning('请选择固件版本'); return; }
    const fwGroup = FIRMWARE_CASCADE.find(g => g.value === fwCascade[0]);
    const fwVer = fwGroup?.children.find(v => v.value === fwCascade[1]);
    setList([...list, { key: `fw-${Date.now()}`, fwName: fwGroup.label, fwVersion: fwVer.label, hasConfig: true, remark: fwRemark }]);
    setFwCascade(null); setFwRemark(''); setAdding(false);
  };

  const fwAddRow = (adding, setAdding, list, setList) => (
    <>
      {adding ? (
        <div style={{ background: '#fafafa', padding: 12, borderRadius: 8, marginTop: 8 }}>
          <Form layout="vertical">
            <Form.Item label="选择固件版本" required>
              <Cascader options={FIRMWARE_CASCADE} value={fwCascade} onChange={setFwCascade} placeholder="固件名称 / 固件版本" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="上传固件配置">
              <Upload maxCount={1} beforeUpload={() => false}><Button icon={<UploadOutlined />}>上传文件</Button></Upload>
            </Form.Item>
            <Form.Item label="备注信息">
              <Input value={fwRemark} onChange={(e) => setFwRemark(e.target.value)} placeholder="选填" />
            </Form.Item>
            <Space>
              <Button type="primary" size="small" onClick={() => handleAddFw(list, setList, setAdding)}>保存</Button>
              <Button size="small" onClick={() => { setAdding(false); setFwCascade(null); setFwRemark(''); }}>取消</Button>
            </Space>
          </Form>
        </div>
      ) : (
        <Button type="dashed" icon={<PlusOutlined />} style={{ marginTop: 8 }} onClick={() => { setFwCascade(null); setFwRemark(''); setAdding(true); }}>添加固件</Button>
      )}
    </>
  );

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>生产配置</Title></div>

      <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 8 }} message="在此处可维护待生产产品的相关配置：License生成规则、标签模板、生产固件、升级固件信息。" />

      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }} bodyStyle={{ padding: '12px 0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Form form={form} layout="inline" style={{ flex: 1, gap: 0 }}>
            <Form.Item style={{ marginRight: 8 }}>
              <Space.Compact>
                <Form.Item name="prodType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">产品名称</Option><Option value="id">产品ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.prodType !== c.prodType} noStyle>
                  {({ getFieldValue }) => getFieldValue('prodType') === 'id' ? (<Form.Item name="prod" noStyle><Input placeholder="产品ID" allowClear style={{ width: 240 }} /></Form.Item>) : (<Form.Item name="prod" noStyle><Select placeholder="请选择产品" allowClear showSearch optionFilterProp="label" style={{ width: 240 }} options={PRODUCTS} /></Form.Item>)}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item style={{ marginRight: 0 }}><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
          </Form>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { createForm.resetFields(); setProdFwList([]); setUpgFwList([]); setAddingProdFw(false); setAddingUpgFw(false); setCreateVisible(true); }}>创建产品配置</Button>
        </div>
      </Card>

      <Card bordered={false}>
        <Table columns={columns} dataSource={dataSource} rowKey="key" pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>

      {/* 创建产品配置 */}
      <Drawer title="创建产品配置" width={900} onClose={() => setCreateVisible(false)} open={createVisible} destroyOnClose
        footer={<div style={{ textAlign: 'right', padding: '10px 16px' }}><Button onClick={() => setCreateVisible(false)} style={{ marginRight: 8 }}>取消</Button><Button type="primary" onClick={() => { message.success('产品配置已保存'); setCreateVisible(false); }}>保存配置</Button></div>}
      >
        <Form form={createForm} layout="vertical">
          <Form.Item name="productId" label="生产产品" rules={[{ required: true, message: '请选择产品' }]}>
            <Select placeholder="请选择产品" showSearch optionFilterProp="label"
              options={PRODUCTS.map(p => { const used = dataSource.some(d => d.productId === p.value); return { ...p, label: `${p.label}${used ? ' - 已配置' : ''}`, disabled: used }; })}
            />
          </Form.Item>
          <Form.Item name="authCode" label={<span>授权规则 <Tooltip title="License号生成规则：企业唯一标识码 + 自定义3位 + 年月日6位 + 随机数4位"><InfoCircleOutlined style={{ color: '#8c8c8c' }} /></Tooltip></span>} rules={[{ required: true, message: '请输入' }, { pattern: /^[A-Za-z0-9]{3}$/, message: '仅支持3位数字或字母' }]} initialValue="HMY">
            <Input addonBefore="010" addonAfter="+ 年月日 + 随机数" maxLength={3} style={{ width: '100%' }} placeholder="3位数字或字母" />
          </Form.Item>
          <Form.Item name="tagTemplate" label={<span>标签模板 <Text type="secondary" style={{ fontSize: 12, fontWeight: 'normal' }}>若无标签？可前往 <Button type="link" style={{ padding: 0, fontSize: 12 }} onClick={() => navigate('/produce/tag')}>《标签管理》</Button></Text></span>}>
            <Select placeholder="请选择标签模板（非必选）" allowClear options={TAG_TEMPLATES} />
          </Form.Item>
        </Form>

        <Divider />
        <div style={{ marginBottom: 24 }}>
          <Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>生产固件</Text>
          <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 6 }} message="生产测试环节需要烧录生产固件请在此处维护固件，工单管理中选择应用生产固件。" />
          {prodFwList.length > 0 && <Table size="small" dataSource={prodFwList} rowKey="key" pagination={false} columns={fwColumns(prodFwList, setProdFwList)} />}
          {fwAddRow(addingProdFw, setAddingProdFw, prodFwList, setProdFwList)}
        </div>

        <Divider />
        <div>
          <Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>升级固件</Text>
          <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 6 }} message="生产过程需对设备进行固件升级（检测），请完善下方固件信息！若生产测试设备无需固件升级，则忽略下方配置。" />
          {upgFwList.length > 0 && <Table size="small" dataSource={upgFwList} rowKey="key" pagination={false} columns={fwColumns(upgFwList, setUpgFwList)} />}
          {fwAddRow(addingUpgFw, setAddingUpgFw, upgFwList, setUpgFwList)}
        </div>
      </Drawer>

      {/* 编辑产品配置 */}
      <Drawer title={`编辑产品配置 - ${editRecord?.productName || ''}`} width={900} onClose={() => setEditVisible(false)} open={editVisible} destroyOnClose
        footer={<div style={{ textAlign: 'right', padding: '10px 16px' }}><Button onClick={() => setEditVisible(false)} style={{ marginRight: 8 }}>取消</Button><Button type="primary" onClick={() => { message.success('产品配置已保存'); setEditVisible(false); }}>保存配置</Button></div>}
      >
        {editRecord && (<>
          <div style={{ marginBottom: 16 }}>
            <Text type="secondary">产品：</Text><Text strong>{editRecord.productName}（{editRecord.productId}）</Text>
          </div>
          <Form layout="vertical" style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: 16 }}>
              <Form.Item label={<span>授权规则 <Tooltip title="License号生成规则：企业唯一标识码 + 自定义3位 + 年月日6位 + 随机数4位"><InfoCircleOutlined style={{ color: '#8c8c8c' }} /></Tooltip></span>} style={{ flex: 1 }}>
                <Input addonBefore="010" addonAfter="+ 年月日 + 随机数" maxLength={3} defaultValue={editRecord.authCode} />
              </Form.Item>
              <Form.Item label="标签模板" style={{ flex: 1 }}>
                <Select placeholder="请选择标签模板（非必选）" allowClear defaultValue={editRecord.tagTemplate} options={TAG_TEMPLATES} />
              </Form.Item>
            </div>
          </Form>

          <div style={{ marginBottom: 24 }}>
            <Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>生产固件</Text>
            <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 6 }} message="生产测试环节需要烧录生产固件请在此处维护固件，工单管理中选择应用生产固件。" />
            {prodFwList.length > 0 && <Table size="small" dataSource={prodFwList} rowKey="key" pagination={false} columns={fwColumns(prodFwList, setProdFwList)} />}
            {fwAddRow(addingProdFw, setAddingProdFw, prodFwList, setProdFwList)}
          </div>

          <Divider />
          <div>
            <Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>升级固件</Text>
            <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 6 }} message="生产过程需对设备进行固件升级（检测），请完善下方固件信息！若生产测试设备无需固件升级，则忽略下方配置。" />
            {upgFwList.length > 0 && <Table size="small" dataSource={upgFwList} rowKey="key" pagination={false} columns={fwColumns(upgFwList, setUpgFwList)} />}
            {fwAddRow(addingUpgFw, setAddingUpgFw, upgFwList, setUpgFwList)}
          </div>
        </>)}
      </Drawer>

      {/* 固件配置弹窗 */}
      <Modal title="固件配置 - 雄迈" open={defaultValVisible} onCancel={() => setDefaultValVisible(false)} destroyOnClose width={1100}
        footer={<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}><Button onClick={() => setDefaultValVisible(false)}>关闭</Button><Button type="primary" style={{ background: '#fa8c16', borderColor: '#fa8c16' }} onClick={() => { message.success('已保存并导出'); setDefaultValVisible(false); }}>保存并导出</Button><Button type="primary" onClick={() => { message.success('已保存'); setDefaultValVisible(false); }}>保存</Button></div>}
      >
        <Form form={defaultValForm} layout="vertical" style={{ marginTop: 16 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px 24px' }}>
            <Form.Item label="硬件类型"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '类型A' }, { value: '2', label: '类型B' }]} /></Form.Item>
            <Form.Item label="硬件板子新旧"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '新板' }, { value: '2', label: '旧板' }]} /></Form.Item>
            <Form.Item label="光源类型"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '红外' }, { value: '2', label: '白光' }, { value: '3', label: '混合' }]} /></Form.Item>
            <Form.Item label="分辨率"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '1080P' }, { value: '2', label: '2K' }, { value: '3', label: '4K' }]} /></Form.Item>
            <Form.Item label="网口配置"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '有线' }, { value: '2', label: '无线' }]} /></Form.Item>
            <Form.Item label="延时关灯开关"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '开启' }, { value: '0', label: '关闭' }]} /></Form.Item>
            <Form.Item label="云台上下方向"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '正向' }, { value: '2', label: '反向' }]} /></Form.Item>
            <Form.Item label="云台左右方向"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '正向' }, { value: '2', label: '反向' }]} /></Form.Item>
            <Form.Item label="移动追踪上下方向"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '正向' }, { value: '2', label: '反向' }]} /></Form.Item>
            <Form.Item label="移动追踪左右方向"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '正向' }, { value: '2', label: '反向' }]} /></Form.Item>
            <Form.Item label="IRCUT方向"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '正向' }, { value: '2', label: '反向' }]} /></Form.Item>
            <Form.Item label="球机水平镜像翻转"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '开启' }, { value: '0', label: '关闭' }]} /></Form.Item>
            <Form.Item label="球机垂直镜像翻转"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '开启' }, { value: '0', label: '关闭' }]} /></Form.Item>
            <Form.Item label="枪机水平镜像翻转"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '开启' }, { value: '0', label: '关闭' }]} /></Form.Item>
            <Form.Item label="枪机垂直镜像翻转"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '开启' }, { value: '0', label: '关闭' }]} /></Form.Item>
            <Form.Item label="灯板输入逻辑"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '高电平' }, { value: '2', label: '低电平' }]} /></Form.Item>
            <Form.Item label="白光灯控制逻辑"><Select placeholder="请选择" allowClear options={[{ value: '1', label: 'PWM' }, { value: '2', label: 'GPIO' }]} /></Form.Item>
            <Form.Item label="红外灯控制逻辑"><Select placeholder="请选择" allowClear options={[{ value: '1', label: 'PWM' }, { value: '2', label: 'GPIO' }]} /></Form.Item>
            <Form.Item label="光敏类型"><Select placeholder="请选择" allowClear options={[{ value: '1', label: 'ADC' }, { value: '2', label: 'GPIO' }]} /></Form.Item>
            <Form.Item label="喇叭反向"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '正向' }, { value: '2', label: '反向' }]} /></Form.Item>
            <Form.Item label="语言"><Select placeholder="请选择" allowClear options={[{ value: '1', label: '中文' }, { value: '2', label: '英文' }, { value: '3', label: '多语言' }]} /></Form.Item>
            <Form.Item label="云台左右角度 (1-10000)"><InputNumber min={1} max={10000} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="云台上下角度 (1-10000)"><InputNumber min={1} max={10000} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="云台左右速度 (1-17)"><InputNumber min={1} max={17} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="云台上下速度 (1-17)"><InputNumber min={1} max={17} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="移动追踪上下步长 (1-10000)"><InputNumber min={1} max={10000} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="移动追踪左右步长 (1-10000)"><InputNumber min={1} max={10000} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="移动追踪复位间隔 (1-3600)"><InputNumber min={1} max={3600} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="播放声音大小 (1-100)"><InputNumber min={1} max={100} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="监听声音大小 (1-100)"><InputNumber min={1} max={100} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="延时关灯时间 (1-12)"><InputNumber min={1} max={12} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
            <Form.Item label="齿轮比 (10-100)"><InputNumber min={10} max={100} placeholder="请输入" style={{ width: '100%' }} /></Form.Item>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ProduceConfig;
